import styled from 'styled-components'

import { VaultsListContainer } from './components/VaultsListContainer'
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs'
import { usePostHogEntityViewed } from 'utils/usePostHogEntityViewed'
import { GLOBAL_BANNER_HEIGHT } from 'components/GlobalBanner/GlobalBanner'
import { useGlobalBanner } from 'utils/useGlobalBanner'

const Page = styled.div<{ $hasBanner: boolean }>`
  min-height: calc(100vh - 462px);
  margin-top: calc(124px + ${props => (props.$hasBanner ? GLOBAL_BANNER_HEIGHT : 0)}px);

  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    margin-top: calc(100px + ${props => (props.$hasBanner ? GLOBAL_BANNER_HEIGHT : 0)}px);

    & > nav {
      padding: 0 20px;
    }

    // & > div {
    //   margin-top: -40px;
    // }
  }
`

export const VaultsContainer = () => {
  usePostHogEntityViewed('sav:vault_list_view')
  const { isEnabled: hasBanner } = useGlobalBanner()

  return (
    <Page $hasBanner={hasBanner}>
      <Breadcrumbs
        items={[
          { label: 'Home', path: '/' },
          { label: 'Vaults', path: '/vaults' },
        ]}
      />
      <VaultsListContainer />
    </Page>
  )
}
